import { LayoutHOC } from "base/ui/layout/layout";
import { createProductionPlanViewDetails } from "./viewDetails";



export const createProductionPlanViewDetailsPage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createProductionPlanViewDetails());
};